import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { Property, RVDocumentPage, RVProperty } from "../../api/Property";
import RVContext from "../../RVContext";
import { extractOData, updateProperty } from "../../RVUtils";
import { RVLookUpTransformer, RVPropertyType } from "../../api/entities";
import * as RVApi from "../../api/api";
import { RVDocumentLookup } from "../../api/api";
import { LocaleUtil, StringUtil } from "@eres/core";
import Strings from "@my-dld/assets/strings";
import { Redirect } from "react-router";
import CheckBoxField from "@eres/forms-web/CheckBoxField";
import { ErrorContainer } from "@eres/forms";
import DateInputField from "@eres/forms-web/DateInputField";
import { dualDataManager } from "@eres/forms/valuemanager/DualDataManager";
import { IdExtractorFallback, lookupConverter, serverDateConverter } from "@my-dld/utils/LookupUtil";
import TextInputField from "@eres/forms-web/TextInputField";
import { WebFormFieldProps } from "@eres/forms-web";
import StateHolder from "@eres/forms/StateHolder";
import { defaultErrorManager } from "@eres/forms/errormanager";
import { RVPropertyHeader } from "./RVPropertyHeader";
import PickerInput from "@eres/forms-web/PickerInput";
import { Lookup } from "@eres/ejari-api/Entity";
import { checkNonEmpty } from "@eres/ejari-web/utils";
import { navigateWithInParent } from "@my-dld/utils/StoreUtils";
import cloneDeep from "lodash/cloneDeep";
import { DocumentItem } from "./RVDocuments";

interface Props extends RoutedViewProps {
}

interface LookupState {
	Usage?: Lookup[];
	EjariTypes?: Lookup[];
	EjariSubTypes?: Lookup[];
	Documents?: RVDocumentLookup[];
	lookupLoadCount: number;
}

interface FieldState {
	hasType: boolean;
	hasSubType: boolean;
}

interface State extends FieldState, LookupState {
	property: Property;
	orgData: Partial<RVProperty>;
	newData: Partial<RVProperty>;
	forceEdit: {
		[ key: string ]: boolean;
	};
	errorContainer: ErrorContainer;
}

class RVPropertyInfo extends Component<Props, State> {
	static contextType = RVContext;
	context!: React.ContextType<typeof RVContext>;
	docRefs: DocumentItem[] | null[] = [];

	constructor( props: Props ) {
		super( props );
		const locState = props.location.state;
		let property: Property = locState && locState.property ? locState.property : undefined;
		if ( property && property.rvData == undefined ) {
			property.rvData = {
				isDataCompleted: false,
			};
		}
		if ( property && property.rvData && property.rvData.oData == undefined ) {
			property.rvData.oData = extractOData( property );
			property.rvData.data = {};
		}
		const pType = property && property ? property.PropertyTypeId : undefined;
		this.state = {
			property: property,
			orgData: property ? property.rvData!.oData! : {},
			newData: property ? property.rvData!.data! : {},
			hasType: pType !== RVPropertyType.LAND,
			hasSubType: pType === RVPropertyType.UNIT || pType === RVPropertyType.VILLA,
			errorContainer: {},
			lookupLoadCount: 0,
			forceEdit: {},
		};
	}

	componentDidMount() {
		const { newData, orgData, hasSubType, hasType, property } = this.state;
		const data = {
			...orgData,
			...newData,
		};
		if ( property ) {
			this.loadLookup( "GetPropertyUsages", "Usage", "EjariUsageId", property.PropertyId + "",
				"" + property.PropertyTypeId + "|" + ( property.IsFreeHold ? "1" : "0" ) );
			let pType = "" + property.PropertyTypeId;
			let eType = "" + data.EjariTypeId;
			let uType = "" + data.EjariUsageId;
			if ( hasType && !StringUtil.isEmptyStringOrNull( uType ) )
				this.loadLookup( "EjariPropertyTypes", "EjariTypes", "EjariTypeId", uType, pType );
			if ( hasSubType && !StringUtil.isEmptyStringOrNull( eType ) )
				this.loadLookup( "EjariPropertySubTypes", "EjariSubTypes", "EjariSubTypeId", eType, "" );
			// this.loadLookup("RVAttachments", "Documents", undefined, "46", "");
		}
	}

	loadLookup( key: string, stateKey: keyof LookupState, dataKey: keyof RVProperty | undefined, parm1: string = "", param2: string = "" ) {
		this.setState( ( ps ) => ( {
			lookupLoadCount: ps.lookupLoadCount + 1,
		} ) );
		RVApi.loadLookupsX( key, parm1, param2 )
		.then( RVApi.validateResponseX ).then( value => {
			let convert = value.map( RVLookUpTransformer );
			this.setState( ( ps ) => ( {
				lookupLoadCount: ps.lookupLoadCount - 1,
			} ) );
			const update: Partial<State> = {};
			const { orgData, forceEdit } = this.state;
			if ( dataKey ) {
				if ( orgData[ dataKey ] ) {
					const v = orgData[ dataKey ];
					const hasLookup = convert.find( x => x.Id === v ) != undefined;
					if ( !hasLookup ) {
						update.forceEdit = {
							...forceEdit,
							[ dataKey ]: true,
						};
					}
				}
			}

			update[ stateKey ] = convert as any;
			this.setState( update as State );
		} ).catch( () => {
			this.setState( ( ps ) => ( {
				lookupLoadCount: ps.lookupLoadCount - 1,
			} ) );
		} );
	}

	render() {
		const { newData, orgData, hasSubType, hasType, property, errorContainer } = this.state;
		if ( property == null )
			return <Redirect to={ "/mydld/rentalvaluation/rvproperties" }/>;
		const data = {
			...newData,
			...orgData,
		};
		const filedProps: Partial<WebFormFieldProps<any, any>> = {
			holder: StateHolder.buildStateHolder( this ),
			valueManager: dualDataManager,
			errorManager: defaultErrorManager,
			required: true,
		};
		return <React.Fragment>
			<RVPropertyHeader property={ property }/>
			<div className="card mb-3">
				<div className="card-header">
					<span> { Strings.property_information } </span>
				</div>
				<div className="card-body">
					<div className={ "row" }>
						<div className="col-md-4">
							<CheckBoxField { ...filedProps }
							               id={ "IsCompletedProperty" }
							               label={ Strings.is_this_completed_property }
							               labelClassName={ "custom-control-label" }
							               error={ errorContainer.IsCompletedProperty }/>
						</div>
					</div>
					<div className="row">
						{ data.IsCompletedProperty === 1 &&
							<div className="col-md-4">
								<DateInputField
									{ ...filedProps }
									label={ Strings.completion_date }
									id={ "PropertyCompletionDate" }
									containerClassName="form-group position-relative"
									valueConverter={ serverDateConverter }
									disabled={ orgData.PropertyCompletionDate ? true : false }
								/>
							</div>
						}

						<div className="col-md-4">
							<TextInputField
								{ ...filedProps }
								id={ "PropertySize" }
								disabled={ data.PropertySize ? true : false }
								containerClassName="form-group"
								label={ Strings.area_size_sq_ft }
							/>
						</div>
						<div className="col-md-4">
							<PickerInput
								{ ...filedProps }
								label={ Strings.usage }
								id={ "EjariUsageId" }
								items={ this.state.Usage }
								formatter={ item => LocaleUtil.getLocalValue( item ) }
								error={ errorContainer.EjariUsageId }
								disabled={ data.EjariUsageId ? true : false }
								toIdentifier={ IdExtractorFallback }
								valueConverter={ lookupConverter }
								containerClassName="form-group"
								onValueChange={ ( itemValue ) => {
									if ( hasType ) {
										this.setState( {
											forceEdit: {
												...this.state.forceEdit,
												EjariTypeId: true,
											},
										}, () => {
											let pType = "" + property.PropertyTypeId;
											let eType = "" + data.EjariTypeId;
											let uType = "" + itemValue;
											this.loadLookup( "EjariPropertyTypes", "EjariTypes", "EjariTypeId", uType, pType );
											if ( hasSubType && !StringUtil.isEmptyStringOrNull( eType ) )
												this.loadLookup( "EjariPropertySubTypes", "EjariSubTypes", "EjariSubTypeId", eType, "" );

										} );
									}

								} }
							/>
						</div>
						{ hasType &&
							<div className="col-md-4">
								<PickerInput
									{ ...filedProps }
									label={ Strings.type }
									id={ "EjariTypeId" }
									items={ this.state.EjariTypes }
									formatter={ item => LocaleUtil.getLocalValue( item ) }
									error={ errorContainer.EjariTypeId }
									disabled={ data.EjariTypeId ? true : false }
									toIdentifier={ IdExtractorFallback }
									valueConverter={ lookupConverter }
									containerClassName="form-group"
									onValueChange={ ( itemValue ) => {
										if ( hasSubType ) {
											this.setState( {
												forceEdit: {
													...this.state.forceEdit,
													EjariSubTypeId: true,
												},
											}, () => {
												this.loadLookup( "EjariPropertySubTypes", "EjariSubTypes", "EjariSubTypeId", "" + itemValue, "" );
											} );
										}
									} }
								/>
							</div>
						}
						{ hasSubType &&
							<div className="col-md-4">
								<PickerInput
									{ ...filedProps }
									label={ Strings.sub_type }
									id={ "EjariSubTypeId" }
									items={ this.state.EjariSubTypes }
									formatter={ item => LocaleUtil.getLocalValue( item ) }
									error={ errorContainer.EjariSubTypeId }
									disabled={ data.EjariSubTypeId ? true : false }
									toIdentifier={ IdExtractorFallback }
									containerClassName="form-group"
									valueConverter={ lookupConverter }/>
							</div>
						}
					</div>
				</div>
			</div>
			{ this.state.Documents && this.state.Documents.length > 0 &&
				<div className="card mb-3">
					<div className="card-header">
						<span> { Strings.documents } </span>
					</div>
					<div className="card-body">
						{ this.state.Documents.map( ( doc, index ) => {
							let currentData: RVDocumentPage[] = [];
							if ( property.rvData && property.rvData.documents ) {
								let ds = property.rvData.documents.find( x => x.lookupId === doc.Identity );
								if ( ds ) {
									currentData = ds.pages;
								}
							}
							return <DocumentItem
								errorContainer={ errorContainer }
								lookup={ doc }
								current={ currentData }
								ref={ ( r ) => {
									this.docRefs[ index ] = r;
								}
								}
							/>;
						} ) }
					</div>
				</div>
			}
			<div className="enoc-add-buyer">
				<button
					className="btn btn_1 btn_style1 btn-sm" data-bs-target="#completedProjectsModal"
					onClick={ this.onSave }
					data-bs-toggle="modal" type="button">
					{ Strings.save }
				</button>
			</div>
		</React.Fragment>;
	}

	validateForm = () => {
		const { newData, orgData, hasSubType, hasType } = this.state;
		const data = {
			...orgData,
			...newData,
		};
		let isValid = true;

		let errorViews: ErrorContainer = {};
		if ( data.IsCompletedProperty )
			isValid = checkNonEmpty( data, "PropertyCompletionDate", errorViews ) && isValid;
		isValid = checkNonEmpty( data, "PropertySize", errorViews ) && isValid;
		isValid = checkNonEmpty( data, "EjariUsageId", errorViews ) && isValid;
		if ( hasType )
			isValid = checkNonEmpty( data, "EjariTypeId", errorViews ) && isValid;
		if ( hasSubType )
			isValid = checkNonEmpty( data, "EjariSubTypeId", errorViews ) && isValid;
		if ( this.docRefs.length > 0 ) {
			for ( let doc of this.docRefs ) {
				if ( doc ) {
					isValid = doc.validate() && isValid;
				}
			}
		}
		this.setState( { errorContainer: errorViews } );

		return isValid;
	};

	onSave = () => {
		if ( this.validateForm() ) {
			const { newData, orgData } = this.state;
			const data = {
				...newData,
				...orgData,
			};
			let property = cloneDeep( this.state.property );
			property.rvData!.isDataCompleted = false;
			property.rvData!.data = newData;
			if ( data.IsCompletedProperty === 0 ) {
				data.PropertyCompletionDate = undefined;
			}
			property.rvData!.documents = [];
			if ( this.docRefs.length > 0 ) {
				for ( let doc of this.docRefs ) {
					if ( doc ) {
						doc.updateProperty( property );
					}
				}
			}
			property.rvData!.isDataCompleted = true;
			updateProperty( property );
			navigateWithInParent( "rentalvaluation", "rvproperties" );
		}
	};
}

export default RVPropertyInfo;
